/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import analytics from './ga'
import Loader from './components/Loader'
import SearchResult from './components/SearchResult'
import SearchMultiple from './components/SearchMultiple'
import ErrorForm from "./components/ErrorForm.vue";
import ErrorMessage from './components/ErrorMessage'
import Vue from 'vue'
import axios from "axios";
import experimentHooks from "./experiment/experimentHooks";
require('./experiment/experimentLoader')

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

let getSignedRequestBody
try {
  getSignedRequestBody = await (
    await import(
      /* webpackChunkName: "link.chunk" */
      './getSignedRequestBody.js'
      )
  ).default
} catch (error) {
  getSignedRequestBody = async (url) => {
    return { url }
  }
}

const app = new Vue({
  el: '#main',
  components: {
    Loader,
    SearchResult,
    SearchMultiple,
    ErrorForm,
    ErrorMessage
  },
  data() {
    return {
      search: null,
    }
  },
  created() {
    this.$root.$on('input-inserted', () => {
      analytics.inputInserted();
    })
    this.$root.$on('search-clicked', () => {
      experimentHooks.clickAds.emit('open')
      analytics.searchClicked();
    })
    this.$root.$on('error-occured', (error, message) => {
      analytics.errorOccured(message || error);
    })
    this.$root.$on('tt-result-received', () => {
      analytics.resultReceived();
    })
    this.$root.$on('download-click', (type) => {
      experimentHooks.clickAds.emit('open')
      analytics.sendDownloadFormat(type);
    })
    this.$root.$on('disabled-button', (type) => {
      const button = document.querySelector('.search-form__button')
      button.disabled = type
    })

  },
  methods: {
    onSearchClick: async function () {
      this.$root.$emit('clear-results')
      this.$root.$emit('error-form-clear')
      this.$root.$emit('disabled-button', true)

      if (!this.search) {
        this.$root.$emit('error-form-message', 'Paste the link to start searching')
        this.$root.$emit('disabled-button', false)
        return
      }

      const isValid = this.checkValidateLink(this.search)
      const isTiktok = /tiktok/.test(this.search)

      this.$root.$emit('clear-error')

      this.$root.$emit('search-clicked')

      this.$root.$emit('loader-state-change', true)


      if (isValid) {
        if (isTiktok) {

          try {
            const reqBody = await getSignedRequestBody(
              this.search.trim()
            )
            const postResponse = await axios.post(
              `/api/convert`,
              reqBody
            )
            this.$root.$emit(
              'tt-result-received',
              postResponse.data
            )
          } catch (error) {
            if (error?.response?.status === 401) {
              const e = error.response.data
              this.$root.$emit('error-occured', e.error_message, 'Unauthorized')
            } else if (
              error?.message ===
              'Request failed with status code 400'
            ) {
              this.$root.$emit(
                'error-occured',
                `The download link not found.`
              )
            } else {
              this.$root.$emit(
                'error-occured',
                `Something went wrong, please try again.`
              )
            }
          }
        } else {
          this.$root.$emit(
            'error-occured',
            `Sorry, it seems that the link is not valid :( Please, try again.`
          )
        }
      } else {
        this.$root.$emit('error-form-message', 'Wrong link format. Paste correct link and try again')
        this.$root.$emit(
          'error-occured', null,
          `Wrong link format. Paste correct link and try again`
        )
      }
      this.$root.$emit('disabled-button', false)
      this.$root.$emit('loader-state-change', false)
    },
    onPaste() {
      window.setTimeout(() => {
        const isValid = this.checkValidateLink(this.search)
        if (isValid) {
          this.$root.$emit('input-inserted', 'link')
          this.onSearchClick()
        }
      }, 10)
    },
    checkValidateLink: function (searchQuery) {
      const urlPattern = /^(http|https):\/\//i;
      return urlPattern.test(searchQuery.trim());
    }

  },

})


const burgerButton = document.querySelector('.header__button-burger')
if (burgerButton) {
  const closeButton = document.querySelector('.header__button-close')
  burgerButton.addEventListener('click' , ()=>{
    toggleMobileMenu()
  })
  closeButton.addEventListener('click' , ()=>{
    toggleMobileMenu()
  })
  function toggleMobileMenu(){
    const menu = document.querySelector('.header__top')
    menu.classList.toggle('header__top_mobile')
    burgerButton.classList.toggle('header__button-burger_disable')
    closeButton.classList.toggle('header__button-close_enable')
  }
}

const langButton = document.querySelector('.header__lang-button')
if (langButton) {
  const langMenu = document.querySelector('.header__lang-menu')
  langButton.addEventListener('click', () => {
    langMenu.classList.toggle('header__lang-menu_show')
  })
}

const backToTop = document.querySelector('.backTop');

if (backToTop) {
  let visible = false;

  window.addEventListener('scroll', () => {
    if (window.pageYOffset > 220) {
      if (!visible) {
        visible = true;
        backToTop.classList.add('backTop_visible');
      }
    } else {
      if (visible) {
        visible = false;
        backToTop.classList.remove('backTop_visible');
      }
    }
  });

  backToTop.addEventListener('click', (event) => {
    event.preventDefault();

    if ('scrollBehavior' in document.documentElement.style) {
      window.scrollTo({
        left: 0,
        top: 0,
        behavior: 'smooth',
      });
    } else {
      window.scrollTo(0, 0);
    }
  });
}

const showQuestion = document.querySelectorAll('.faq__btn')

showQuestion.forEach(function (elem) {
  elem.addEventListener('click', (event) => {
    const index = event.target.dataset.target

    const content = document.querySelector(`.faq__paragraph[data-target="${index}"`)
    const img = document.querySelector(`.faq__btn-img[data-target="${index}"`)

    img.classList.toggle('faq__btn-img_active')
    content.classList.toggle('faq__paragraph_active')

  })
})

const input = document.querySelector('.search-form__input')
if (input) {
  const mainText = input.placeholder
  const animatedText = 'https://';
  let index = 0;
  setInterval(() => {
    input.placeholder = mainText + animatedText.substring(0, index + 1);
    index = (index + 1) % (animatedText.length + 10);
  }, 300)
}
